import { TemplateRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { ProductListDetailComponent } from '../product-list-detail/product-list-detail.component';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var ProductListComponent = (function () {
    function ProductListComponent(apiService, translate, authService, modalService) {
        this.apiService = apiService;
        this.translate = translate;
        this.authService = authService;
        this.modalService = modalService;
        this.itemsPerPage = 40;
        this.modal = null;
        this.modalData = null;
        this.searchProductID = '';
        this.searchProductName = '';
        this.groups = [];
        this.currentPage = 1;
        this.loading = false;
        this.list = [];
        this.selectedValues = [];
        this.allChecked = false;
        this.parent = null;
        this.fileToUpload = null;
        this.complete = false;
        this.fileReport = {
            success: '',
            duplicate: '',
            operate_fail: '',
            validate_fail: ''
        };
        this.isSave = true;
        this.productDetails = [];
    }
    ProductListComponent.prototype.ngOnInit = function () {
        this.subs = this.translate.onLangChange.subscribe(function (res) {
        });
        this.pageChanged();
        this.isSave = false;
    };
    ProductListComponent.prototype.open = function (parent) {
        this.isSave = true;
        this.chosenFile = this.translate.instant("PRODUCT-IMPORT.NO-FILE-CHOSEN");
        this.parent = parent;
        this.fileReport = {
            success: '',
            duplicate: '',
            operate_fail: '',
            validate_fail: ''
        };
        this.modal = this.modalService.open(this.modalTemplate, {
            backdrop: 'static',
            size: "lg",
            centered: true,
        });
    };
    ProductListComponent.prototype.reload = function () {
        this.pageChanged();
    };
    ProductListComponent.prototype.pageChanged = function () {
        this.loadData();
    };
    ProductListComponent.prototype.optionChanged = function () {
        this.search();
    };
    ProductListComponent.prototype.openModal = function (data, index) {
        this.detailModal.open(this, data);
    };
    ProductListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.loadData();
    };
    ProductListComponent.prototype.loadData = function () {
        var _this = this;
        this.loading = true;
        var data = {
            page: this.currentPage,
            items_per_page: this.itemsPerPage,
            product_id: this.searchProductID,
            name_en: this.searchProductName
        };
        this.apiService.getProducts(data)
            .pipe(finalize(function () {
            _this.loading = false;
        }))
            .subscribe(function (res) {
            _this.productDetails = res.results;
            if (res) {
                _this.totalItems = res.count;
                _this.selectedValues = Array(_this.productDetails.length).fill(false);
            }
        });
    };
    ProductListComponent.prototype.confirmDelete = function (index) {
        this.modalData = this.productDetails[index];
        this.modal = this.modalService.open(this.deleteConfirmationModal, { backdrop: 'static', centered: true });
    };
    ProductListComponent.prototype.confirmedDelete = function (productId) {
        var _this = this;
        this.apiService.deleteProduct(productId).subscribe(function () {
            _this.loadData();
            _this.sniff('DELETE_PRODUCT', _this.modalData.product_id + ';' + _this.modalData.name_en);
            _this.revertBack();
        });
    };
    ProductListComponent.prototype.clearSearch = function () {
        this.searchProductID = '';
        this.searchProductName = '';
        this.loadData();
    };
    ProductListComponent.prototype.revertBack = function () {
        this.modal.close();
        this.modal = null;
        this.modalData = null;
    };
    ProductListComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'MANAGE_PRODUCT',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    ProductListComponent.prototype.selectDeselectAll = function (checked) {
        this.selectedValues = Array(this.productDetails.length).fill(checked);
        this.allChecked = checked;
    };
    ProductListComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    Object.defineProperty(ProductListComponent.prototype, "isAdmin", {
        get: function () {
            return this.authService.isAdmin();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductListComponent.prototype, "isIT", {
        get: function () {
            return this.authService.isIT();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductListComponent.prototype, "isAccountant", {
        get: function () {
            return this.authService.isAccountant();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductListComponent.prototype, "isAccountantAdmin", {
        get: function () {
            return this.authService.isAccountantAdmin();
        },
        enumerable: true,
        configurable: true
    });
    ProductListComponent.prototype.forTemplate = function (type) {
        var _this = this;
        if (type === 'csv') {
            this.apiService.getTemplateCSVABB().subscribe(function (data) {
                _this.apiService.createDownloadFile(data, 'sample_product_csv.csv');
            }, function (error) {
                console.log(error);
            });
        }
    };
    ProductListComponent.prototype.handleFileInput = function (files) {
        this.fileToUpload = files.item(0);
        this.chosenFile = this.fileToUpload.name;
        this.complete = false;
        this.isSave = false;
    };
    ProductListComponent.prototype.reportUploadResultComplete = function (data) {
        if (data.success.length !== 0) {
            this.fileReport.success = data.success + ' ' + this.translate.instant("ABB-DASHBOARD.UPLOAD.SUCCESS");
            this.complete = true;
            this.chosenFile = this.translate.instant("ABB-DASHBOARD.IMPORT-CSV") + " " + this.translate.instant("ABB-DASHBOARD.UPLOAD.UPLOAD-COMPLETE");
            return;
        }
        this.fileReport.validate_fail = data.validate_fail;
        this.fileReport.operate_fail = data.operation_fail;
        this.complete = true;
        this.chosenFile = this.translate.instant("ABB-DASHBOARD.UPLOAD.SUCCESS");
    };
    ProductListComponent.prototype.reportUploadResultError = function (error) {
        if (error.error.validate_fail || error.error.operation_fail) {
            this.fileReport.validate_fail = error.error.validate_fail;
            this.fileReport.operate_fail = error.error.operation_fail;
        }
        else {
            this.fileReport.validate_fail = error.error;
        }
    };
    ProductListComponent.prototype.uploadFileToDatabase = function () {
        var _this = this;
        if (this.fileToUpload) {
            this.loading = true;
            var document_1 = new FormData();
            document_1.append('file', this.fileToUpload);
            var get_format = this.fileToUpload.name.split(".");
            var file_format = get_format.slice(-1).pop();
            this.fileReport = {
                success: '',
                duplicate: '',
                operate_fail: '',
                validate_fail: ''
            };
            if (file_format === 'csv') {
                this.apiService.uploadCSVABB(document_1).subscribe(function (data) {
                    _this.loading = false;
                    _this.reportUploadResultComplete(data);
                    _this.loadData();
                }, function (error) {
                    _this.loading = false;
                    _this.reportUploadResultError(error);
                    _this.isSave = true;
                });
            }
            this.fileToUpload = null;
        }
        else {
            this.isSave = true;
            this.chosenFile = this.translate.instant("ABB-DASHBOARD.NO-FILE-CHOSEN");
        }
    };
    ProductListComponent.prototype.submit = function () {
        if (this.complete) {
            this.modal.close();
            return;
        }
        this.uploadFileToDatabase();
        return;
    };
    return ProductListComponent;
}());
export { ProductListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list/product-list.component.ts.pre-build-optimizer.js